import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M12.5 8C9.85 8 7.45 8.99 5.6 10.6L3.71 8.71C3.08 8.08 2 8.52 2 9.41V15C2 15.55 2.45 16 3 16H8.59C9.48 16 9.93 14.92 9.3 14.29L7.39 12.38C8.78 11.22 10.55 10.5 12.51 10.5C15.67 10.5 18.4 12.34 19.7 15C19.97 15.56 20.61 15.84 21.2 15.64C21.91 15.41 22.27 14.6 21.95 13.92C20.23 10.42 16.65 8 12.5 8Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2 5.565C2 5.25296 2.25296 5 2.565 5C2.87704 5 3.13 5.25296 3.13 5.565V8.83466C3.36937 8.53503 3.67764 8.18636 4.05201 7.83695C5.04605 6.90918 6.55247 5.935 8.50002 5.935C10.458 5.935 11.8475 6.91894 12.7265 7.86555C13.1662 8.33903 13.4861 8.81074 13.6964 9.16414C13.8019 9.34138 13.8807 9.49034 13.934 9.59694C13.9607 9.65028 13.981 9.69314 13.9952 9.72378C14.0023 9.7391 14.0078 9.75137 14.0118 9.76039L14.0167 9.77144L14.0183 9.77508L14.0189 9.77642L14.0191 9.77697C14.0192 9.77721 14.0193 9.77744 13.5 10L14.0193 9.77744C14.1422 10.0643 14.0093 10.3964 13.7225 10.5193C13.4361 10.6421 13.1044 10.5097 12.9811 10.2236L12.9808 10.223L12.9808 10.2229L12.9806 10.2226L12.9793 10.2195L12.9693 10.1976C12.9598 10.177 12.9445 10.1446 12.9233 10.1023C12.8809 10.0175 12.8152 9.893 12.7254 9.74211C12.5451 9.43926 12.2713 9.03596 11.8985 8.63445C11.1525 7.83106 10.042 7.065 8.50002 7.065C6.94756 7.065 5.70399 7.84082 4.82303 8.66305C4.38538 9.07152 4.04864 9.4813 3.82179 9.78865C3.80109 9.81669 3.78134 9.84383 3.76254 9.87001H7.435C7.74704 9.87001 8 10.123 8 10.435C8 10.747 7.74704 11 7.435 11H2.565C2.25296 11 2 10.747 2 10.435V10.435V5.565Z"
  />
);

export const HistoryUndoIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="HistoryUndo" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
